module.exports = __webpack_public_path__ + "static/media/spo.50e96853.jpg";